<h3>Order Breakdown</h3>

<div class="card">
  <p-chart
    type="bar"
    [data]="data"
    [options]="options"
    (onDataSelect)="selectData($event)"
    [style.background-color]="bgColor"></p-chart>
</div>
